import { NavigateFunction, Location } from 'react-router-dom';

export function closeGlobalDrawerRoute(
    navigate: NavigateFunction,
    location: Location,
    keepSearchParams: boolean = false
) {
    // Remove everything after and including /d/ from the current path
    const newPath = location.pathname.replace(/(?:\/d\/\/?.*)/, '');
    const search = keepSearchParams ? location.search : '';

    navigate(newPath + search);
}
